import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { PROVIDER_COLUMN, PURCHASES_PROVIDER_MODULE } from "../constant/purchasesReceiptConstant";

export const setPurchasesReceiptProviderPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: PURCHASES_PROVIDER_MODULE,
        default_columns: PROVIDER_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
